import { Button, Container, Group, Text, Title } from "@mantine/core";

import classes from "./styles.module.css";
import AccountDeletedIllustration from "./Illustration";
import { Colors, ContactInformation } from "../../Lib/Data";
import { Link, useParams } from "react-router-dom";
import { usePerformRequest } from "../../Lib/usePerformRequest";
import { Endpoints } from "../../Lib/Endpoints";
import MegaLoader from "../../Components/MegaLoader";

export default function AccountDeleted() {
  const params = useParams();
  const verificationToken = params.verificationToken ?? "";
  const { data, isLoading } = usePerformRequest({
    route: Endpoints.GetConfirmAccountDeletion(verificationToken),
    method: "DELETE",
  });
  return (
    <div className={classes.root}>
      <Container>
        {isLoading ? (
          <MegaLoader />
        ) : (
          <div className={classes.inner}>
            <AccountDeletedIllustration className={classes.image} />
            <div className={classes.content}>
              <Title className={classes.title}>Account Deleted 😭</Title>
              <Text size="lg" ta="center" className={classes.description}>
                Your account has been successfully deleted, and all associated
                data has been permanently removed from our platform in
                accordance with our data privacy policy. Should you choose to
                return in the future, we’d be happy to welcome you back.
              </Text>
              <Group justify="center">
                <Link to="/">
                  <Button size="md" color={Colors.GreenPrimary}>
                    Go Home
                  </Button>
                </Link>
                <a href={`mailto:${ContactInformation.email}`}>
                  <Button
                    size="md"
                    variant="outline"
                    color={Colors.GreenPrimary}
                  >
                    Contact Us
                  </Button>
                </a>
              </Group>
            </div>
          </div>
        )}
      </Container>
    </div>
  );
}
